import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const MailIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M17.63,2.18H2.37c-1.31,0-2.37,1.06-2.37,2.37v10.9c0,1.31,1.06,2.37,2.37,2.37h15.26c1.31,0,2.37-1.06,2.37-2.37V4.55c0-1.31-1.06-2.37-2.37-2.37ZM17.63,3.43c.25,0,.5.09.7.25l-8.09,7.47L1.97,3.5c.13-.05.26-.07.4-.07h15.26ZM17.63,16.57H2.37c-.62,0-1.12-.5-1.12-1.12V4.55h0s8.57,7.9,8.57,7.9c.24.22.61.22.85,0l8.08-7.46v10.46c0,.62-.5,1.12-1.12,1.12Z" />
 </svg>,
 "Mail"
);
